import script from "./SkuList.vue?vue&type=script&lang=ts&setup=true"
export * from "./SkuList.vue?vue&type=script&lang=ts&setup=true"

import "./SkuList.vue?vue&type=style&index=0&id=3f4128b2&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Client_OdpJ/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f4128b2"]])

export default __exports__